// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".color--primary[data-v-f904ea1e]{color:#c81919}.button-social[data-v-f904ea1e]{display:inline-flex;cursor:pointer;padding:7px 10px;margin:3px 1.5px;border-radius:3px;-moz-border-radius:3px;-webkit-border-radius:3px}.share--wa img[data-v-f904ea1e]{width:26px}.share--button[data-v-f904ea1e]{cursor:pointer;margin-left:12px}.share--button .v-icon[data-v-f904ea1e]{color:#c81919;font-size:36px}", ""]);
// Exports
module.exports = exports;
